import React from "react";
import { SEO, MarkdownContent, DynamicForm } from "@bluefin/components";
import { Grid, Segment } from "semantic-ui-react";
import { navigate, graphql } from "gatsby";

import WebsiteLayout from "../components/WebsiteLayout.jsx";
import {
  getComponentFiles,
  getComponentContentNodeContent,
} from "../utils/utils";
import "../style/donation-current-client.css";

export default class DonationCurrentClientPage extends React.PureComponent {
  render() {
    const { data } = this.props;
    const {
      fishermanBusiness,
      fishermanBusinessWebsitePage,
      dpdpbcbafpaffhmfjhmgohdgeionglkidpdp,
    } = data;

    return (
      <WebsiteLayout>
        <SEO
          businessName={fishermanBusiness.name}
          pageName={fishermanBusinessWebsitePage.title}
          title={fishermanBusinessWebsitePage.seoTitle}
          description={fishermanBusinessWebsitePage.description}
          images={getComponentFiles({
            components: fishermanBusinessWebsitePage.components,
            componentName: "HeroElement",
            numToSelect: 1,
          })}
          ogUrl={"https://www.stranded.salon/donation-current-client/"}
        />
        <Grid
          className={"custom-page-donation-current-client custom-page-grid"}
          style={{}}
          stackable={true}
        >
          <Grid.Row
            className={"fnkfebjlihnoehlh"}
            style={{ padding: 16 }}
            columns={1}
          >
            <Grid.Column className={"affaicmlcacneioa"} style={{ padding: 16 }}>
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <MarkdownContent
                  className={"text-block"}
                  style={{}}
                  content={getComponentContentNodeContent({
                    components: fishermanBusinessWebsitePage.components,
                    componentName: "MarkdownContent",
                    componentId: "58be0869-0563-4d12-8091-c3e60d327301",
                    defaultValue: "",
                  })}
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
          <Grid.Row
            className={"gfbcipjoibgneiai"}
            style={{ padding: "100px" }}
            textAlign={"center"}
            verticalAlign={"middle"}
          >
            <Grid.Column
              className={"fgamdfglboncenpo"}
              style={{
                border: "solid 3px #4B3F35",
                padding: "50px",
                background: "#C4AC8E",
              }}
              width={6}
              textAlign={"left"}
              verticalAlign={"top"}
            >
              <div data-component={navigate} />
              <Segment
                className={""}
                style={{
                  border: "none",
                  boxShadow: "none",
                  background: "none",
                }}
              >
                <DynamicForm
                  className={""}
                  style={{}}
                  businessId={2761}
                  businessInfoId={7907}
                  websiteId={9492}
                  locationId={3028}
                  componentConfigurationId={240112}
                  header={dpdpbcbafpaffhmfjhmgohdgeionglkidpdp.data.header}
                  fields={
                    dpdpbcbafpaffhmfjhmgohdgeionglkidpdp.data.dynamicFormFields
                  }
                  onSubmitSuccess={({ name }) =>
                    navigate("/thank-you-for-contact-us")
                  }
                />
              </Segment>
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </WebsiteLayout>
    );
  }
}

export const query = graphql`
  query {
    fishermanBusiness {
      name
    }
    fishermanBusinessWebsitePage(_id: { eq: 41073 }) {
      title
      seoTitle
      description
      components {
        files {
          file
        }
        order
        fastId
        componentIdentifier
        contentNodes {
          content
        }
      }
    }
    dpdpbcbafpaffhmfjhmgohdgeionglkidpdp: fishermanWebsiteComponent(
      fastId: { eq: "CustomForm" }
      componentIdentifier: { eq: "1d5cc26f-1cd7-4019-8874-4d9212142321" }
    ) {
      data {
        header
        dynamicFormFields {
          name
          label
          style {
            color
            marginTop
            marginBottom
          }
          content
          options {
            label
            value
          }
          required
          inputType
          widgetType
          placeholder
          sendEmailToSelectedLocation
        }
      }
    }
  }
`;
